// QR Kiosk v2 — §8.4 surface context. Lets deep citation chips (KioskCite) and
// image thumbs (MidasMessages/BotImageThumb) open the fullscreen page/document
// artifact takeover WITHOUT prop-drilling through the markdown renderers.
// Provided by KioskMidasFullV2 (which owns the stage state + artifact map).
// Pure TS — React context only, no components, no MUI.
import React from "react";

export interface KioskMidasSurface {
  /** Is there a resolvable page/document artifact for this page number? */
  resolvePage: (page: number) => boolean;
  /** Open the page artifact for this page → stage "artifact". */
  openPageArtifact: (page: number) => void;
  /** Open a bot-hosted image (thumbnail tap) → stage "artifact". */
  openImageArtifact: (url: string, title?: string) => void;
}

export const MidasSurfaceContext = React.createContext<KioskMidasSurface | null>(null);
